import { render, staticRenderFns } from "./TaskMainWindowButtonsBar.component.vue?vue&type=template&id=2b5af0c6&scoped=true&"
import script from "./TaskMainWindowButtonsBar.component.vue?vue&type=script&lang=js&"
export * from "./TaskMainWindowButtonsBar.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskMainWindowButtonsBar.component.vue?vue&type=style&index=0&id=2b5af0c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5af0c6",
  null
  
)

export default component.exports